module.exports = __webpack_public_path__ + "img/megaphone-color-icon.3d6d4344.svg";